export const PenPath = (sliderValue: number, radius: number, t: number) => {
  switch (sliderValue) {
    case 0:
    default:
      return 0;
    case 1:
      return radius;
    case 2:
      return radius * Math.sin(t / 2.5);
    case 3:
      return 0.5 * radius + radius * Math.sin(2 * t);
    case 4:
      return 0.5 * radius + radius * Math.sin(3 * t);
    case 5:
      return 0.5 * radius + radius * Math.sin(4 * t);
    case 6:
      return 0.5 * radius + radius * Math.sin(5 * t);
    case 7:
      return 0.5 * radius + radius * Math.cos(6 * t);
    case 8:
      return 0.5 * radius + (radius * Math.sin(2 * t)) / 5;
    case 9:
      return 0.5 * radius + (radius * Math.sin(3 * t)) / 5;
    case 10:
      return 0.5 * radius + (radius * Math.sin(4 * t)) / 5;
    case 11:
      return 0.5 * radius + (radius * Math.sin(5 * t)) / 5;
    case 12:
      return 0.5 * radius + (radius * Math.cos(6 * t)) / 5;
    case 13:
      return radius * Math.sin(2.4 * t);
    case 14:
      return radius * Math.sin(3.3333 * t);
    case 15:
      return radius * Math.sin(4.25 * t);
    case 16:
      return radius * Math.sin(5.2 * t);
    case 17:
      return radius * Math.cos(6.05 * t);
    case 18:
      return radius * Math.sin(2.4 * t);
    case 19:
      return radius * Math.sin(3.3 * t);
    case 20:
      return radius * Math.sin(4.2 * t);
    case 21:
      return radius * Math.sin(5.1 * t);
    case 22:
      return radius * Math.cos(6.05 * t);
    case 23:
      return (1*radius / 100) * 5 * t;
    case 24:
      return (1*radius / 100) * 50 * Math.log(t + 1);
    case 25:
      return (1*radius / 100) * (t * t);
    // case 26:
    //   return radius * Fade.powerOneAndHalf(Math.random());
  }
};
